import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IERegion } from '../interfaces/eregion';
import { IERegionFilter } from '../interfaces/eregion-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class EngineiusRegionService extends EditService<IERegion, IERegionFilter> {
  url = '/api/eregions';
  entityTitle = 'EngineiusRegion';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(): Promise<any> {
    return this.handleRequest(
      this.http.get<IERegion[]>(`${this.url}/getAll`),
      this.handlersFactory.getForReadAll(),
    );
  }

  createregion(region: IERegion, isNew: boolean): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    let successMsg = isNew ? 'Region added.' : 'Region updated.';

    return this.handleRequest(
      this.http.post(this.url + '/save', region, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
}
